import { render, staticRenderFns } from "./VisitorActivities.vue?vue&type=template&id=cb6050c0"
import script from "./VisitorActivities.vue?vue&type=script&lang=js"
export * from "./VisitorActivities.vue?vue&type=script&lang=js"
import style0 from "./VisitorActivities.vue?vue&type=style&index=0&id=cb6050c0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports